// メッセージMap
export const MessageMap = {
    "create_datetime_start": "作成日時（開始）",
    "create_datetime_end": "作成日時（終了）"
};
